import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionServerSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { fetchResourceActions } from '~src/resourceActions/actions/ResourceActions';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { AllSiteUsersSpace, AllSiteUsersSpaceDispatchProps, AllSiteUsersSpaceOwnProps, AllSiteUsersSpaceStateProps } from './AllSiteUsersSpace';

const mapStateToProps: MapStateToProps<AllSiteUsersSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedUsers: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
  doesTheServerHaveMoreThanOneSite: SessionServerSelectors.doesTheServerHaveMoreThanOneSite(state),
  canAddUsers: getSessionManagementServiceInstance().canSessionManageUsersOrActOnResource('User', ['CREATE_USER_WITH_ROLE']),
});

const mapDispatchToProps: MapDispatchToProps<AllSiteUsersSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
  updateBreadcrumbs,
  fetchResourceActions,
}, dispatch);

export const ConnectedAllSiteUsersSpace: React.ComponentClass<AllSiteUsersSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllSiteUsersSpace);
